import styled from "@emotion/styled";

export const ClickAreaExpander = styled.span`
  display: inline-block;
  padding: 0 5px;
`;
